import energy_card_multi_1 from 'assets/img/cards/energy_card_multi_1.svg';
import energy_card_multi_2 from 'assets/img/cards/energy_card_multi_2.svg';
import energy_card_pink from 'assets/img/cards/energy_card_pink.svg';
import energy_card_red from 'assets/img/cards/energy_card_red.svg';
import energy_card_blue from 'assets/img/cards/energy_card_blue.svg';
import energy_card_green from 'assets/img/cards/energy_card_green.svg';
import energy_card_multi_3 from 'assets/img/cards/energy_card_multi_3.svg';
import energy_card_blue_green from 'assets/img/cards/energy_card_blue_green.svg';
import energy_card_yellow from 'assets/img/cards/energy_card_yellow.svg';

export const energyCardsSrcArray = [energy_card_blue_green, energy_card_red, energy_card_multi_2, energy_card_green, energy_card_multi_3, energy_card_pink, energy_card_blue, energy_card_multi_1, energy_card_yellow,]
